export const TYPES = {
    PHRASE: 'phrase',
    NOTICE: 'notice',
    BLOCK: 'block'
}
export const TYPE_TX = {
    [TYPES.PHRASE]: '常用语设置',
    [TYPES.NOTICE]: '通知设置',
    [TYPES.BLOCK]: '屏蔽列表'
}
export const TABS = [
    {
        key: TYPES.PHRASE,
        name: '常用语设置',
        show: ['consultant']
    }
]

export const AUTOREPLY_TYPES = ['设置为自动回复', '设置为第一回复', '设置为第二回复', '设置为第三回复']
export const AUTOREPLY_LISTS = [
    {
        key: 1,
        name: '设置为第一回复'
    },
    {
        key: 2,
        name: '设置为第二回复'
    },
    {
        key: 3,
        name: '设置为第三回复'
    },
    {
        key: 0,
        name: '取消该条回复'
    },
]